import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export interface AlertProps {
  /**
   * Title of the alert
   */
  title: string;
  /**
   * Body/Content of the alert
   */
  message: string;
  /**
   * Confirm button label
   */
  confirmLabel: string;
  /**
   * Cancel button label
   */
  cancelLabel?: string;
  /**
   * Function to be called when the confirm button is clicked
   */
  onConfirm: () => void;
  /**
   * Function to be called when the cancel button is clicked
   */
  onCancel?: () => void;
}

/**
 * Component used to whow a confirmation alert that will execute the onConfirm function or the onCancel function
 * depending on which button is pressed by the user
 */
export default function ConfirmationAlert(props: AlertProps) {
  const buttons = [
    {
      label: props.confirmLabel,
      onClick: props.onConfirm,
    }
  ]

  if (props.cancelLabel && props.onCancel) {
    buttons.push({
      label: props.cancelLabel,
      onClick: props.onCancel,
    })
  }

  const submit = () => {
    confirmAlert({
      title: props.title,
      message: props.message,
      buttons: buttons
    });
  };
    // Return the result of calling the `submit` function, which will immediately display the confirmation dialog box
    return (
        submit()
    );
}
